import { useEffect } from 'react';
import { useModalAction } from '@/components/ui/modal/modal.context';

const OldWebViewDetector = () => {
  const { openModal } = useModalAction();

  useEffect(() => {
    // Check if running in old webview

    const params = new URLSearchParams(window.location.search);

    const hasOldAppParams =
      params.get('beta') === 'true' &&
      params.get('tabbar') === 'false';

    const inWebView = !!(
      hasOldAppParams
    );

    if (inWebView) {
      // Open the app update required modal
      openModal('APP_UPDATE_REQUIRED');
    }
  }, [openModal]);

  return null;
};

export default OldWebViewDetector;
